import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';

import { AuthSlice } from './auth/reducer';
import { DLModeSlice } from './dlMode/reducer';
import { FavoritesSlice } from './favorites/reducer';
import { PostSlice } from './post/reducer';
import { AppSlice } from './app/reducer';
import { OrderSlice } from './order/reducer';
import { SubscriptionSlice } from './subscription/reducer';
import storage from 'redux-persist/lib/storage';
import { UsersSlice } from './users/reducer';

const AppPersistedReducer = persistReducer(
    {
        key: 'app',
        storage: storage,
        whitelist: ['onboarded'],
    },
    AppSlice.reducer,
);

const AuthPersistedReducer = persistReducer(
    {
        key: 'auth',
        storage: storage,
        whitelist: ['user', 'guest'],
    },
    AuthSlice.reducer,
);

const DLModePersistedReducer = persistReducer(
    {
        key: 'dlMode',
        storage: storage,
        whitelist: ['textColor', 'backgroundColor'],
    },
    DLModeSlice.reducer,
);

const FavoritesPersistedReducer = persistReducer(
    {
        key: 'favorites',
        storage: storage
    },
    FavoritesSlice.reducer,
);

const PostPersistedReducer = persistReducer(
    {
        key: 'post',
        storage: storage,
        whitelist: ['postsData', 'postDataLastRequest'],
    },
    PostSlice.reducer,
);

const reducers = combineReducers({
    app: AppPersistedReducer,
    dlMode: DLModePersistedReducer,
    auth: AuthPersistedReducer,
    favorites: FavoritesPersistedReducer,
    post: PostPersistedReducer,
    order: OrderSlice.reducer,
    subscription: SubscriptionSlice.reducer,
    users: UsersSlice.reducer
});

export default reducers;